import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

import { DialogManagerService } from '@src/services';

import * as _str from 'underscore.string';
import _ from 'lodash';

import { cmsActions } from '@src/store/reducers/cmsReducer';
import { Store } from '@src/store';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';

@Component({
    selector: 'cms-item',
    template: require('./cms-item.component.html'),
    styles: [require('./cms-item.component.scss')]
})
export class CmsItemComponent implements OnInit {
    @Output() public onDelete = new EventEmitter();
    @Output() public onTest = new EventEmitter<any>();
    @Output() public onCancel = new EventEmitter<any>();

    public hasItemEditable = true;
    public cmsTypeList = [];

    private unSubscribe: any;
    private _cms: any;
    private tempCms: any;

    constructor(
        private store: Store,
        private dialogManagerService: DialogManagerService,
        private translatePipe: TranslatePipe) {
    }

    @Input() public set cms(value) {
        if (value && !value.details) {
            value.details = {};
            value.details.details = {};
        }

        this.tempCms = this.deepCopy(value);
        this._cms = value;
        this.hasItemEditable = !this.cms;
        this.setCMSType();
    }

    public get cms() {
        return this._cms;
    }

    public set selectedCms(value) {
        this.cms.type = value.id;
        this.cms.typeName = value.name;
    }

    public get selectedCms() {
        if (this.cmsTypeList && this._cms) {
            const type = this.cmsTypeList.filter(type => type.id == this._cms.type)[0];
            if (type) {
                this._cms.type = type.id;
                return type;
            }
        }
    }

    public ngOnInit() {
        this.unSubscribe = this.store.subscribe(() => {
            const cmss = this.store.getState().cmss;
            if (cmss && cmss.cms_types) {
                this.cmsTypeList = cmss.cms_types.filter((item: any) => item.id !== 6);
                this.setCMSType();
            }
        });
        this.store.dispatch({ type: cmsActions.GET_CMS_TYPES });
    }

    public async save() {
        const saveCmsRequiredFields = [
            { key: 'type', value: 'CMS Type' },
            { key: 'name', value: 'CMS Name' }
        ];
        delete this._cms.test;
        const copyCms = this.deepCopy(this._cms);
        const isValidCMS = await this.validateCMS(copyCms, saveCmsRequiredFields);
        delete copyCms.userName;
        delete copyCms.password;
        delete copyCms.typeName;
        this.hasItemEditable = false;
        if (isValidCMS) {
            if (this._cms.isNew) {
                this.unSubscribe = this.store.subscribe(() => {
                    if (this.store.getState().user.cmss) {
                        this._cms.id = this.store.getState().cmss.cms.id;
                        delete this._cms.isNew;
                        delete copyCms.isNew;
                        this.unSubscribe();
                    }
                });

                this._cms.id = null;
                if (!copyCms.id) {
                    copyCms.id = -1;
                }

                if (!copyCms.details) {
                    copyCms.details = {};
                    copyCms.details.details = {};
                }

                copyCms.details.lastModified = '30/07/2017 13:47';

                this.store.dispatch({
                    type: cmsActions.ADD_CMS,
                    payload: { cmsData: copyCms }
                });
            } else {
                const saveID = this._cms.id;
                this.unSubscribe = this.store.subscribe(() => {
                    if (this.store.getState().user.cms) {
                        this._cms.id = saveID;
                        this.unSubscribe();
                    }
                });

                this.store.dispatch({
                    type: cmsActions.SAVE_CMS,
                    payload: { cmsData: copyCms }
                });
            }
        }
    }

    public cancel() {
        const cms = Object.assign({}, this.tempCms);
        this._cms = cms;
        this.onCancel.emit(cms);
    }

    public async testCMSCon() {
        const testCmsRequiredFields = [
            { key: 'password', value: 'Password' },
            { key: 'userName', value: 'User Name' },
            { key: 'type', value: 'CMS Type' },
            { key: 'name', value: 'CMS Name' }
        ];

        const copyCMS = this.deepCopy(this._cms);
        const isValidCMS = await this.validateCMS(copyCMS, testCmsRequiredFields);
        delete copyCMS.typeName;

        if (!copyCMS.id) {
            copyCMS.id = -1;
        }

        copyCMS.details.lastModified = '30/07/2017 13:47';
        if (isValidCMS) {
            this.onTest.emit(copyCMS);
        }
    }

    public setCMSType() {
        if (this.cmsTypeList && this._cms) {
            let type = this.cmsTypeList.filter(type => type.id == this._cms.type)[0];
            if (type) {
                this._cms.type = type.id;
                return type.name;
            }
        }
    }

    private async validateCMS(cms: any, requiredFields: any): Promise<boolean> {
        let valid = true;
        requiredFields.forEach((reqField: any) => {
            if (!cms[reqField.key]) {
                valid = false;
                return;
            }
        });

        if (!cms.details) {
            valid = false;
        }

        if (!valid) {
            const translations = await this.translatePipe.transform(['ERROR_REQUIRED_FIELDS_LIST', 'ERROR']);
            const mappedFields = requiredFields.map((field: any) => field.value).join(', ');
            this.dialogManagerService.showErrorDialog({
                title: translations['ERROR'],
                text: _str.sprintf(translations['ERROR_REQUIRED_FIELDS_LIST'], mappedFields + ', Server Path')
            });
        }

        return valid;
    }

    private deepCopy(obj: any) {
        if (!obj) {
            return obj;
        }

        return _.cloneDeep(obj);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/cms-management/cms-item/cms-item.component.ts